import { createStyles, useTheme } from 'antd-style'
import dayjs from 'dayjs'
import { template } from 'lodash'

import { pick } from '@eastcoal/common/utils/object'

import { TradeSessionStatus } from '../../../../../../enums/TradeSessionStatus'
import { useAuctionDetailStore } from '../../../Store/hooks/useStore'

const timeTemplate = template(
  '[<span class="time-value">]${value}[</span>][<span class="time-unit">]${unit}[</span>]'
)

const countdownTemplate = [
  { value: 'D', unit: '天' },
  { value: 'H', unit: '时' },
  { value: 'm', unit: '分' },
  { value: 's', unit: '秒' }
]
  .map(timeTemplate)
  .join('')

const useStyles = createStyles(
  ({ token }, { containerBg }: { containerBg: string }) => ({
    container: {
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      gap: token.padding,
      height: 60,
      lineHeight: 1,
      paddingInlineStart: 40,
      fontSize: token.fontSizeHeading5,
      fontWeight: 500,
      color: token.colorWhite,
      verticalAlign: 'middle',
      filter: `drop-shadow(0 3px 3px ${token.colorBorder})`,
      ['&::after']: {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        right: -token.paddingLG - 12,
        zIndex: -1,
        height: 60 + 12,
        backgroundColor: containerBg,
        clipPath:
          'polygon(0 50%, 40px 0, 100% 0, 100% calc(100% - 12px), calc(100% - 12px) 100%, calc(100% - 12px) calc(100% - 12px),  40px calc(100% - 12px))'
      }
    },
    dot: {
      ['&::before']: {
        content: '""',
        position: 'relative',
        top: -1,
        marginInlineEnd: token.marginXS,
        display: 'inline-block',
        width: '0.5em',
        height: '0.5em',
        borderRadius: '50%',
        backgroundColor: token.colorWhite
      }
    },
    line: {
      display: 'inline-block',
      width: 1,
      height: '1.5em',
      backgroundColor: token.colorWhite,
      opacity: 0.5
    },
    countdown: {
      lineHeight: 1,
      ['&>.time-value']: {
        marginInline: token.marginXS,
        fontSize: token.fontSizeHeading3
      },
      ['&>.time-unit']: {
        position: 'relative',
        top: -2
      }
    }
  })
)

const DEFAULT_DURATION = dayjs.duration(0)

export const StatusRibbon = () => {
  const { endTime, statusInfo } = useAuctionDetailStore(state =>
    pick(state, ['endTime', 'statusInfo'])
  )

  const {
    status,
    statusText = 'N/A',
    timeLabel = 'N/A',
    duration = DEFAULT_DURATION
  } = statusInfo || {}

  const timeText =
    status === TradeSessionStatus.BID_END
      ? endTime
      : duration.format(countdownTemplate)

  const theme = useTheme()

  const { styles } = useStyles({
    containerBg:
      status === TradeSessionStatus.BIDDING
        ? theme.colorPrimary
        : status === TradeSessionStatus.BID_END
          ? '#A2BDF2'
          : '#AAAEB7'
  })

  return (
    <div className={styles.container}>
      <span className={styles.dot}>{statusText}</span>
      <span className={styles.line} />
      <span> {timeLabel}</span>
      <span
        dangerouslySetInnerHTML={{
          __html: timeText ?? ''
        }}
        className={styles.countdown}
      />
    </div>
  )
}
